import React from "react";
import ToggleButton from "../custom/ToggleButton";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";

const TriggerDetails = ({ item }) => {
  console.log("item", item);
  return (
    <div className="flex flex-col gap-2 relative py-3 px-4 rounded-md border border-zinc-700 bg-zinc-800 transition-colors duration-150 ease-in-out">
      <div className="flex items-center gap-2 mb-5">
        <div className="flex items-center gap-1">
          
            <div
              className="flex flex-shrink-0 rounded items-center justify-center w-7 h-7 p-0.5 border border-zinc-300 bg-zinc-100"
            >
              <img src={"https://oqlous.inqbator.in/assets/oqlous.svg"} alt="Trigger icon" />
            </div>
          
          {/* {item.trigger.map((i) => (
            <div
              key={i.image}
              className="flex flex-shrink-0 rounded items-center justify-center w-7 h-7 p-0.5 border border-zinc-300 bg-zinc-100"
            >
              <img src={i.image} alt="Trigger icon" />
            </div>
          ))} */}
        </div>
        <strong className="flex-1 truncate text-lg font-medium ml-2">
          {item.name}
        </strong>
      </div>
      <h2 className="text-xl text-white">Integrations</h2>
      {item.apps_expanded.map((i, index) => (
        <div
          key={index}
          className="w-full bg-zinc-900 rounded-lg px-4 py-3 flex flex-col gap-3"
        >
          <div className="flex items-center gap-2">
            <div
              key={i.image}
              className="flex flex-shrink-0 rounded items-center justify-center w-5 h-5 p-0.5 border border-zinc-300 bg-zinc-100"
            >
              <img src={i.image} alt="Trigger icon" />
            </div>
            <span>{i.label}</span>
          </div>

          {i.triggerPhrase && (
            <div class="flex items-center py-1 px-2 border border-zinc-700 rounded-[4px] bg-zinc-800 text-sm w-fit">
              <span class="font-semibold">Specific Phrase or Keyword</span>: "
              {i.triggerPhrase}"
            </div>
          )}
        </div>
      ))}
      {item.task_description && (
        <p className="text-sm font-normal text-zinc-200">
          Workflow: {item.task_description}
        </p>
      )}
      <h2 className="text-xl text-white mt-4">Functions</h2>
      {item.functionalities.map((i, index) => (
        <li
          key={index}
          className="px-3 py-1 rounded-lg bg-zinc-900 text-sm text-zinc-300"
        >
          {i}
        </li>
      ))}
    </div>
  );
};

export default TriggerDetails;
